import React from 'react';
import { zoneCalc } from '../../utils/zoneCalc';
import _ from 'lodash';
import {countFilter, playerTypeFilter} from '../../utils/filter/dataFilter';
import colorCalcObj from '../../utils/color/colorCalc';
import statCalc from '../../utils/stat/statCalc';
import { useTranslation } from 'react-i18next';

function LocationChart({title, data, filter, playerType, battingHand, dataType, statYn}) {
    const { t } = useTranslation();

    let index = ['1_1', '2_1', '3_1', '1_2', '2_2', '3_2', '1_3', '2_3', '3_3', 11, 12, 13, 14];
    if(!data || data.length === 0) {
        return (
            <div>
                <div style={{textAlign:'center', width:'260px', height:'170px', 
                display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                    No Data
                </div>
                <div style={{textAlign:'center'}}>{t(title)}</div>
            </div>
        )
    }

    let width = 120;
    let height = 200;
    let perWidth = width/5;
    let halfWidth = width/2;

    let {type, count} = filter;
    let filterData = (type === 'total') ? data : playerTypeFilter(data, type, playerType);
    let secondFilterData = (count === 'total') ? filterData : countFilter(filterData, count);

    let calcData = _.countBy(secondFilterData, (item) => {
        let calcString = zoneCalc(width, width, item, playerType);
        return calcString;
    });

    let groupData = _.groupBy(secondFilterData, (item) => {
        let calcString = zoneCalc(width, width, item, playerType);
        return calcString;
    });

    let zoneData = {};
    let maxValue = _.max(Object.values(calcData));
    let dataLength = secondFilterData ? secondFilterData.length : 0;

    _.forEach(index, (item) => {
        let pitchCnt = calcData[item] ? calcData[item] : 0;
        let relativeZoneRate = maxValue ? (pitchCnt/maxValue) : 0;
        let zoneRate = dataLength ? parseInt((pitchCnt/dataLength)*100) : 0;
        let stat = statCalc(groupData[item]);

        let zoneText = (statYn ? stat[dataType] : ( dataType === 'pitchCnt' ? pitchCnt : zoneRate+"%" ));
        let zoneColor = (statYn ? colorCalcObj(zoneText, dataType) : colorCalcObj(relativeZoneRate, dataType));

        zoneData[item] = { 
            zoneText, ...zoneColor
        };
    });

    const fontSize = '12px';
    const zoneFontSize = statYn ? '9px' : '11px';

    const outerZonePoint1 = 18;
    const outerZonePoint2 = 102;
    const outerZonePoint3 = 112;

    const addPoint = 3;

    const innerZonePoint1 = (perWidth+(perWidth*0.5));
    const innerZonePoint2 = innerZonePoint1+addPoint;
    const innerZonePoint3 = (perWidth*2+(perWidth*0.5));
    const innerZonePoint4 = innerZonePoint3+addPoint;
    const innerZonePoint5 = (perWidth*3+(perWidth*0.5));
    const innerZonePoint6 = innerZonePoint5+addPoint;

    const batterPointY = 0;
    const leftBatterPointX = 10;
    const rightBatterPointX = 190;
    const batterWidth = 60;
    const batterHeight = 150;

    // const statDataType = statYn ? dataType : 'pitchCnt';
    const statDataType = 'zoneText';
    const statColorType = 'bgColor';
    const statTextType = 'textColor';

    let leftImagePath = 'left_batter.png';
    let rightImagePath = 'right_batter.png';
    let leftImageHidden = 'block';
    let rightImageHidden = 'block';

    if(playerType === 'batter') { // reverse
        if(battingHand === 'R') {
            leftImagePath = 'blue_l.png';
            rightImageHidden = 'none';
        } else {
            rightImagePath = 'blue_r.png';
            leftImagePath = 'none';
        }
    } else { // pitcher
        if(filter['type'] === 'R') {
            rightImagePath = 'blue_r.png';
            leftImagePath = 'none';
        } else if(filter['type'] === 'L') {
            leftImagePath = 'blue_l.png';
            rightImagePath = 'none';
        } else {

        }
    }

    let plateType = (playerType === 'batter') ? 'homeplate_small.png' : 'homeplate_small_rotate.png';

    return (
    <>
    <div style={{textAlign:'center'}}>
        <svg width="260" height="170">
            <g transform={`translate(${leftBatterPointX},${batterPointY})`} style={{display:leftImageHidden}}>
                <image href={`${process.env.PUBLIC_URL}/image/${leftImagePath}`} width={batterWidth}/>
            </g>
            <g transform={`translate(${rightBatterPointX},${batterPointY})`} style={{display:rightImageHidden}}>
                <image href={`${process.env.PUBLIC_URL}/image/${rightImagePath}`} width={batterWidth}/>
            </g>
            <g transform='translate(70,25)'>
                <path id="z_11" d={`M0,0L${halfWidth},0L${halfWidth},${perWidth}L${perWidth},${perWidth}L${perWidth},${halfWidth}L0,${halfWidth}L0,0`}
                fill={zoneData[11][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={outerZonePoint1} y={outerZonePoint1}
                style={{fontSize: fontSize, fill:zoneData[11][statTextType]}}>{zoneData[11][statDataType]}</text>

                <path id="z_12" d={`M${halfWidth},0L${width},0L${width},${halfWidth}L${perWidth*4},${halfWidth}L${perWidth*4},${perWidth}L${halfWidth},${perWidth}L${halfWidth},0`} 
                fill={zoneData[12][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={outerZonePoint2} y={outerZonePoint1} 
                style={{fontSize: fontSize, fill: zoneData[12][statTextType]}}>{zoneData[12][statDataType]}</text>

                <path id="z_13" d={`M0,${halfWidth}L0,${width}L${halfWidth},${width}L${halfWidth},${perWidth*4}L${perWidth},${perWidth*4}L${perWidth},${halfWidth}L0,${halfWidth}`} 
                fill={zoneData[13][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={outerZonePoint1} y={outerZonePoint3} 
                style={{fontSize: fontSize, fill: zoneData[13][statTextType]}}>{zoneData[13][statDataType]}</text>

                <path id="z_14" d={`M${halfWidth},${perWidth*4}L${perWidth*4},${perWidth*4}L${perWidth*4},${halfWidth}L${width},${halfWidth}L${width},${width}L${halfWidth},${width}L${halfWidth},${perWidth*4}`} 
                fill={zoneData[14][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={outerZonePoint2} y={outerZonePoint3} 
                style={{fontSize: fontSize, fill: zoneData[14][statTextType]}}>{zoneData[14][statDataType]}</text>


                <path id="z_1" d={`M${perWidth},${perWidth}L${perWidth*2},${perWidth}L${perWidth*2},${perWidth*2}L${perWidth},${perWidth*2}`} 
                fill={zoneData['1_1'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint1} y={innerZonePoint2} 
                style={{fontSize: zoneFontSize, fill: zoneData['1_1'][statTextType]}}>{zoneData['1_1'][statDataType]}</text>

                <path id="z_2" d={`M${perWidth*2},${perWidth}L${perWidth*3},${perWidth}L${perWidth*3},${perWidth*2}L${perWidth*2},${perWidth*2}`} 
                fill={zoneData['2_1'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint3} y={innerZonePoint2} 
                style={{fontSize: zoneFontSize, fill: zoneData['2_1'][statTextType]}}>{zoneData['2_1'][statDataType]}</text>

                <path id="z_3" d={`M${perWidth*3},${perWidth}L${perWidth*4},${perWidth}L${perWidth*4},${perWidth*2}L${perWidth*3},${perWidth*2}`} 
                fill={zoneData['3_1'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint5} y={innerZonePoint2} 
                style={{fontSize: zoneFontSize, fill: zoneData['3_1'][statTextType]}}>{zoneData['3_1'][statDataType]}</text>

                <path id="z_4" d={`M${perWidth},${perWidth*2}L${perWidth*2},${perWidth*2}L${perWidth*2},${perWidth*3}L${perWidth},${perWidth*3}`} 
                fill={zoneData['1_2'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint1} y={innerZonePoint4} 
                style={{fontSize: zoneFontSize, fill: zoneData['1_2'][statTextType]}}>{zoneData['1_2'][statDataType]}</text>

                <path id="z_5" d={`M${perWidth*2},${perWidth*2}L${perWidth*3},${perWidth*2}L${perWidth*3},${perWidth*3}L${perWidth*2},${perWidth*3}`} 
                fill={zoneData['2_2'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint3} y={innerZonePoint4} 
                style={{fontSize: zoneFontSize, fill: zoneData['2_2'][statTextType]}}>{zoneData['2_2'][statDataType]}</text>

                <path id="z_6" d={`M${perWidth*3},${perWidth*2}L${perWidth*4},${perWidth*2}L${perWidth*4},${perWidth*3}L${perWidth*3},${perWidth*3}`} 
                fill={zoneData['3_2'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint5} y={innerZonePoint4} 
                style={{fontSize: zoneFontSize, fill: zoneData['3_2'][statTextType]}}>{zoneData['3_2'][statDataType]}</text>

                <path id="z_7" d={`M${perWidth},${perWidth*3}L${perWidth*2},${perWidth*3}L${perWidth*2},${perWidth*4}L${perWidth},${perWidth*4}`} 
                fill={zoneData['1_3'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint1} y={innerZonePoint6} 
                style={{fontSize: zoneFontSize, fill: zoneData['1_3'][statTextType]}}>{zoneData['1_3'][statDataType]}</text>

                <path id="z_8" d={`M${perWidth*2},${perWidth*3}L${perWidth*3},${perWidth*3}L${perWidth*3},${perWidth*4}L${perWidth*2},${perWidth*4}`} 
                fill={zoneData['2_3'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint3} y={innerZonePoint6} 
                style={{fontSize: zoneFontSize, fill: zoneData['2_3'][statTextType]}}>{zoneData['2_3'][statDataType]}</text>

                <path id="z_9" d={`M${perWidth*3},${perWidth*3}L${perWidth*4},${perWidth*3}L${perWidth*4},${perWidth*4}L${perWidth*3},${perWidth*4}`} 
                fill={zoneData['3_3'][statColorType]} stroke="#fff" strokeWidth={1}></path>
                <text className="numbers" textAnchor="middle" x={innerZonePoint5} y={innerZonePoint6} 
                style={{fontSize: zoneFontSize, fill: zoneData['3_3'][statTextType]}}>{zoneData['3_3'][statDataType]}</text>
            </g>
            <g transform='translate(105,155)'>
                <image href={`${process.env.PUBLIC_URL}/image/${plateType}`} width={50}/>
            </g>
        </svg>
        <div style={{textAlign:'center'}}>{t(title)}</div>
    </div>
    </>
    );
}

export default LocationChart;